"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Style = void 0;

var _styledComponents = require("styled-components");

var _device = require("./device");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    padding: calc(var(--i-medium) - (0.375rem / 2)) var(--i-medium);\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      &:hover,\n      &:focus {\n        &::after {\n          transform: scaleX(1);\n        }\n      }\n\n      &:active {\n        &::after {\n          transform-origin: right;\n          transform: scaleX(0);\n        }\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      &:active {\n        &::after {\n          transform: scaleX(1);\n        }\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n\n    transition: var(--transition);\n\n    &::after {\n      content: '';\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      height: 1px;\n      background-color: currentColor;\n      transform: scaleX(0);\n      transform-origin: left;\n      transition: transform var(--transition);\n    }\n\n    ", "\n\n    ", "\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    border: 1px solid ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    border-top: 1px solid ", ";\n    border-right: 1px solid ", ";\n    border-left: 1px solid ", ";\n    border-bottom: 1px solid ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Style = {
  borderWithBottom: function borderWithBottom(_ref) {
    var colorAll = _ref.colorAll,
        colorBottom = _ref.colorBottom;
    return (0, _styledComponents.css)(_templateObject(), colorAll, colorAll, colorAll, colorBottom);
  },
  borderAll: function borderAll(_ref2) {
    var color = _ref2.color;
    return (0, _styledComponents.css)(_templateObject2(), color);
  },
  linkUnderline: function linkUnderline() {
    return (0, _styledComponents.css)(_templateObject3(), _device.Device.mobile((0, _styledComponents.css)(_templateObject4())), _device.Device.desktop((0, _styledComponents.css)(_templateObject5())));
  },
  inputPadding: function inputPadding() {
    return (0, _styledComponents.css)(_templateObject6());
  }
};
exports.Style = Style;